import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import { DownloadButton } from '@/components/buttons';
import { OldDocumentsToggle } from '@/sections/documents/OldDocumentsToggle';
import { DocumentSection } from '@/sections/documents/DocumentSection';
import { useRouter } from 'next/router';
import { FILES } from '@/constants/files';
import { Text } from '@/components/typography';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
export function DeferredPaymentConditions(props) {
  const $ = _c(68);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["termsAndConditions"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t1;
  if ($[1] !== t) {
    t1 = t("categories.1.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconDeferredPayment className="h-7 w-7 text-blue-500 lg:h-10 lg:w-10" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("categories.1.text");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className="mb-8">{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("categories.1.subtitle");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t5}</h3>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("categories.1.list.1");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <li>{t7}</li>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("categories.1.list.2");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <li>{t9}</li>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("categories.1.list.3");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <li>{t11}</li>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("categories.1.list.4");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <li>{t13}</li>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t12 || $[30] !== t14 || $[31] !== t8) {
    t15 = <ul className="mb-8 list-disc space-y-3 pl-5 marker:text-blue-500 lg:mb-12">{t8}{t10}{t12}{t14}</ul>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t14;
    $[31] = t8;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== locale) {
    t16 = FILES(locale);
    $[33] = locale;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const t17 = t16.termsAndConditionsDeferredPayment;
  let t18;
  if ($[35] !== t) {
    t18 = t("categories.1.documents.current");
    $[35] = t;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t16.termsAndConditionsDeferredPayment || $[38] !== t18) {
    t19 = <DownloadButton to={t17} testId="termsAndConditionsDeferredPaymentCurrent" analyticsParam="termsAndConditionsDeferredPaymentCurrent">{t18}</DownloadButton>;
    $[37] = t16.termsAndConditionsDeferredPayment;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== isCsLanguage || $[41] !== locale || $[42] !== t) {
    t20 = isCsLanguage && <DownloadButton to={FILES(locale).preContractualInformationDeferredPayment} testId="preContractualInformationDeferredPayment" analyticsParam="preContractualInformationDeferredPayment">{t("categories.1.documents.preContractualInformation")}</DownloadButton>;
    $[40] = isCsLanguage;
    $[41] = locale;
    $[42] = t;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t19 || $[45] !== t20) {
    t21 = <div className="flex flex-col items-start gap-2">{t19}{t20}</div>;
    $[44] = t19;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t) {
    t22 = t("show");
    $[47] = t;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t) {
    t23 = t("hide");
    $[49] = t;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== locale || $[52] !== t) {
    let t25;
    if ($[54] !== t) {
      t25 = t26 => {
        const {
          path,
          date,
          customLabel
        } = t26;
        return <div className="mb-2 lg:mb-4" key={path}><DownloadButton to={path} testId="termsAndConditionsOld" analyticsParam="termsAndConditionsOld" variant="old" className="sm:w-full">{customLabel ? <Text as="p" variant="p3">{customLabel}</Text> : <Trans t={t} i18nKey="categories.1.documents.oldConditions">{date}</Trans>}</DownloadButton></div>;
      };
      $[54] = t;
      $[55] = t25;
    } else {
      t25 = $[55];
    }
    t24 = FILES(locale).oldTermsAndConditionsDeferredPayment.map(t25);
    $[51] = locale;
    $[52] = t;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[56] !== t22 || $[57] !== t23 || $[58] !== t24) {
    t25 = <div className="mt-4"><OldDocumentsToggle closedTitle={t22} openedTitle={t23}>{t24}</OldDocumentsToggle></div>;
    $[56] = t22;
    $[57] = t23;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== props || $[61] !== t1 || $[62] !== t15 || $[63] !== t21 || $[64] !== t25 || $[65] !== t4 || $[66] !== t6) {
    t26 = <DocumentSection title={t1} icon={t2} {...props}>{t4}{t6}{t15}{t21}{t25}</DocumentSection>;
    $[60] = props;
    $[61] = t1;
    $[62] = t15;
    $[63] = t21;
    $[64] = t25;
    $[65] = t4;
    $[66] = t6;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  return t26;
}